import { render, staticRenderFns } from "./BidRow.vue?vue&type=template&id=31282993&"
import script from "./BidRow.vue?vue&type=script&lang=js&"
export * from "./BidRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports